function SystemConfigPage() {
  return <></>;
}
export default SystemConfigPage;
